var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rexer_events__list" },
    [
      _vm.events.length < 1
        ? _c("div", { staticClass: "rexer_events__content text-center" }, [
            _vm._v("\n    " + _vm._s(_vm.notfound) + "\n  ")
          ])
        : _c(
            "div",
            { staticClass: "rexer_events__content" },
            [
              _c(
                "transition-group",
                {
                  staticClass: "rexer_events__content-wrap",
                  attrs: { name: "list", tag: "div" }
                },
                _vm._l(_vm.events, function(item) {
                  return _c("event-component", {
                    key: item.id,
                    attrs: { event: item, destination: _vm.destination },
                    on: { makeReservation: _vm.reservationHandle }
                  })
                }),
                1
              )
            ],
            1
          ),
      _vm._v(" "),
      _vm.reservation
        ? _c("reservation-component", {
            attrs: { "data-event": _vm.payload },
            on: { offHandle: _vm.offHandle }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }